import React from "react";

const Disclaimer = () => {
  return (
    <div className="text-center py-10 md:mx-20 mx-5">
      <h4 className="font-bold text-2xl">Disclaimer</h4>
      <div className="py-6 text-justify">
        <p>
          This website is owned and operated by NeoLiv Real Estate Private
          Limited (Company). The website, and all contents, materials,
          information, products and services provided on the website is for
          general purposes only and is provided on an “as is” and “as available”
          basis. The Company expressly disclaims all liability in respect to
          actions taken or not taken based on any or all the contents of this
          website. The Company will in no circumstance be liable for any
          expense, loss or damage including, without limitation, indirect or
          consequential loss or damage, or any expense, loss or damage
          whatsoever arising from the use of data, arising out of or in
          connection with the use of this website. The Company makes no warranty
          that: (a) the website will meet your requirements; (b) the website
          will be available on an uninterrupted, timely, secure, or error-free
          basis; (c) the results that may be obtained from the use of the
          website or any services offered through the website will be accurate
          or reliable. The Company shall not be liable for any errors, omissions
          or inaccuracies in any content or loss of data, information in any
          form or other matters whatsoever which result from the use of this
          website. No information given under this website creates a warranty or
          expand the scope of any warranty that cannot be disclaimed under
          applicable law. The use of the website is solely at your own risk.
          This website is for guidance only. It does not constitute part of an
          offer or contract. The text, images, graphics, video and audio used on
          this website belong to the Company. No material from this website may
          be copied, modified, reproduced, republished, uploaded, transmitted,
          posted or distributed in any form. All rights not expressly granted
          herein are reserved. No reproduction of any part of the website may be
          sold or distributed for commercial gain, nor shall it be modified or
          incorporated in any other work, publication or website, whether in
          hard copy or electronic format, including postings to any other
          website. Unauthorized use of the materials appearing on this website
          may violate copyright, trademark and other applicable laws, and could
          result in criminal or civil penalties. NEOLIV is the registered
          well-known trademark of NeoLiv Property Holding Private Limited. This
          trademark may not be used in any manner without prior written consent
          from NeoLiv Property Holding Private Limited. The logos and marks
          appearing in this website are registered and/or pending registration.
          The use or misuse of these trademarks or any other content on this
          website, is strictly prohibited. Some links within the website may
          lead to other websites, including those operated and maintained by
          third parties. The Company includes these links solely as a
          convenience to you, and the presence of such a link does not imply a
          responsibility for the linked site or an endorsement of the linked
          site, its operator, its contents or under RERA. The Company makes no
          representations whatsoever about any other website which you may
          access through website. In no event, the Company will be liable to any
          party for any direct, indirect, special or other consequential damages
          for any use of this website, or any other hyperlinked website,
          including without limitation, any lost profits, business interruption,
          loss of programs or other data on your information handling system or
          otherwise, even if we are expressly advised of the possibility of such
          damages. The Company may change, modify or discontinue any aspect of
          its website at any time, including, its content or features and
          reserves the right to change the terms and conditions applicable to
          use of the website. Such changes shall be effective immediately upon
          notice, which shall be placed on the website and the user shall be
          bound by such modifications. In no event shall the Company and/or its
          affiliates, officers, employees or agents be liable for any direct,
          indirect, punitive, incidental, special, consequential damage (or any
          damages whatsoever including, without limitation, damages for loss of
          use, data or profits, arising out of or in any way connected with the
          use or performance of this website and/or any website linked to it.
          Nothing on this website constitutes advertising, marketing, booking,
          selling or an offer for sale, or invitation to purchase a unit in any
          project in any manner by the Company. By accessing this website, the
          viewer/user confirms that the information including brochures on this
          website are solely for informational purposes only and the viewer/user
          has not relied on this information for making any booking/purchase in
          any project of the Company. The particulars on the website are being
          modified in terms of the stipulations/recommendations under the RERA
          Act and rules made thereunder and accordingly may not be fully in line
          thereof as of date. You are therefore requested to directly verify all
          details and aspects of any proposed booking/acquisition of
          units/premises, directly with our authorised sales team/Company prior
          to concluding any decision for buying any unit(s) in any of the
          projects The design & specifications are subject to change without
          prior notice. The computer-generated images are the artist's
          impression and are an indicative of the actual designs. The Company
          will not be accepting any bookings or allotments based on the images,
          material, stock photography, projections, details, and descriptions
          that are currently available and/or displayed on the website. By using
          or accessing the website, the user agrees, acknowledges, and accepts
          all the terms and conditions of the disclaimer without any
          qualification or limitation. The foregoing is subject to the
          prevailing laws of India and the courts in India shall have the
          exclusive jurisdiction on any dispute that may arise out of the use of
          this website. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;
